// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import {
  HOVER_TINT,
  PlotLayout,
  toDayBand,
} from '@/membership/utilities/chart-geometry';
import { Box, alpha } from '@mui/material';

interface Props {
  day: number | null;
  layout: PlotLayout;
  dayCount: number;
}

/**
 * The tint behind the day under the cursor, drawn as one band rather than as a
 * background on the day's own column.
 *
 * A column that carried its own tint had to be rebuilt whenever the hovered day
 * changed, which on a year of three pixel bars meant rebuilding the whole grid
 * every few pixels of travel. Moving one band costs nothing.
 */
export function ChartHoveredDay(props: Props) {
  if (props.day === null) return null;

  const band = toDayBand(props.day, props.layout, props.dayCount);
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: `${String(band.left)}px`,
        width: `${String(band.width)}px`,
        backgroundColor: (theme) =>
          alpha(theme.palette.text.primary, HOVER_TINT),
        pointerEvents: 'none',
      }}
    />
  );
}
